import { Column, Entity } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_alert')
export class AlertEntity extends BaseEntity {
	@Column('varchar', { name: '_params', length: 255 })
	public params!: string;

	@Column('varchar', { name: '_type', length: 255 })
	public type!: string;
}
